exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.v-expansion-panel__body {\r\n  margin: 0px 20px 20px 20px;\n}\r\n", ""]);

